import { ValueOf } from '../utilities/types';

const ruleParameters = {
  AUDITOR_STATUSES: { id: 'auditorStatuses', name: 'Auditor statuses' },
  BUSINESS_MONITORED_DATAPOINTS: { id: 'businessMonitoredDatapoints', name: 'Business monitored datapoints' },
  CATEGORY: { id: 'category', name: 'Category' },
  CHANGE_FREQ: { id: 'changeFreq', name: 'Change frequency', riskBased: true },
  CHANGE_MONTHS_LIMIT: { id: 'changeMonthsLimit', name: 'Period', unit: 'months' },
  COLLECT_FIELDS: { id: 'collectFields', name: 'Collect fields' },
  COMMON_THRESHOLD: { id: 'commonThreshold', name: 'Common threshold' },
  CONNECTED_ENTITIES_TO_CHECK: { id: 'connectedEntitiesToCheck', name: 'Entities to check' },
  COUNTRIES: { id: 'countries', name: 'Countries' },
  COUNTRY_CODE: { id: 'countryCode', name: 'Country' },
  DATAPOINT_TO_CHECK: { id: 'dataPointToCheck', name: 'Datapoint to check' },
  DATE_TO_TRACK: { id: 'dateToTrack', name: 'Date to track' },
  DEFAULT_COMMON_THRESHOLD: { id: 'default.commonThreshold', name: 'Default common threshold' },
  DEFAULT_THRESHOLDS: { id: 'default.thresholds', name: 'Default thresholds' },
  DEFAULT_THRESHOLD: { id: 'defaultThreshold', name: 'Default threshold' },
  DEVIATION: { id: 'threshold', name: 'Deviation', unit: '%' },
  DEVIATION_DIRECTION: { id: 'deviationDirection', name: 'Deviation direction' },
  DIRECTION: { id: 'direction', name: 'Direction' },
  ENTITY_CONNECTED_ACCOUNT_THRESHOLD: { id: 'threshold', name: 'Account count threshold' },
  EXPECTED_COUNTRIES: { id: 'expectedCountries', name: 'Expected countries' },
  FORM_COMMON_THRESHOLD: { id: 'form.commonThreshold', name: 'Form common threshold' },
  FORM_THRESHOLDS: { id: 'form.thresholds', name: 'Form thresholds' },
  FORM_IDS: { id: 'formIds', name: 'FormIds' },
  FROM: { id: 'timeWindow.from', name: 'From' },
  HIT_RATIO: { id: 'hitRatio', name: 'Hit ratio', unit: '%' },
  INCLUDE_ANONYMOUS_IPS: { id: 'includeAnonymousIps', name: 'Include anonymous IPs' },
  INDIVIDUALS_MONITORED_DATAPOINTS: { id: 'individualMonitoredDatapoints', name: 'Individual monitored datapoints' },
  KYC_FORM_DATA_MAX_AGE: { id: 'kycFormDataMaxAge', name: 'KYC form max age', unit: 'days' },
  KYC_PARAMS: { id: 'kycParams', name: 'KYC parameters', unit: 'days' },
  LEGAL_SCORE: { id: 'legalScore', name: 'Legal score threshold' },
  LOWER_AGE_LIMIT: { id: 'lowerAgeLimit', name: 'Lower age threshold', unit: 'years' },
  LOWEST_ACCEPTABLE_INCOME: { id: 'threshold', name: 'Lowest acceptable income' },
  LOOKBACK_PERIOD: { id: 'lookbackPeriod', subIds: ['amount', 'unit'], name: 'Lookback period' },
  MERCHANT_CATEGORY_CODE: { id: 'merchantCategoryCode', name: 'Merchant Category Code (MCC)' },
  MINIMUM_NUMBER_OF_OBSERVATIONS: { id: 'minimumNumberOfObservations', name: 'Minimum number of observations' },
  MINIMUM_USAGE_TIME: { id: 'minimumUsageTime', subIds: ['amount', 'unit'], name: 'Minimum usage time' },
  MULTIPLIER: { id: 'multiplier', name: 'Multiplier' },
  NEW_IP_PERIOD: { id: 'newIpPeriod', subIds: ['amount', 'unit'], name: 'New IP period' },
  OPERATOR: { id: 'operator', name: 'Operator' },
  OPERATOR_THRESHOLD: { id: 'operatorParameters.threshold', name: 'Threshold' },
  PARAMETER_PRIORITY: { id: 'parameterPriority', name: 'Parameter priority' },
  PERIOD_IN_MONTHS: { id: 'periodInMonths', name: 'Period', unit: 'months' },
  PERIOD_TO_CONSIDER: { id: 'periodToConsider', subIds: ['amount', 'unit'], name: 'Period to consider' },
  PERIOD: { id: 'period', subIds: ['amount', 'unit'], name: 'Period' },
  PROVIDER: { id: 'identificationInfo.providerName', name: 'Provider' },
  SHARED_IP_THRESHOLD: { id: 'threshold', name: 'Entity count threshold' },
  ENTITY_DISTINCT_IP_THRESHOLD: { id: 'threshold', name: 'IP count threshold' },
  SHOULD_PURCHASE: { id: 'shouldPurchase', name: 'Should purchase data' },
  SNI_CODES: { id: 'sniCodes', name: 'Blocked SNI codes' },
  THRESHOLD_MODE: { id: 'thresholdMode', name: 'Threshold mode' },
  TO: { id: 'timeWindow.to', name: 'To' },
  TRANSACTION_TYPE_CONFIGURATION: { id: 'shouldFilterOnTypes', name: 'Filter on transaction types' },
  TRANSACTION_MONITORING_MODE: { id: 'transactionMonitoringMode', name: 'Transaction monitoring mode' },
  TRANSACTION_DIRECTION: { id: 'transactionDirection', name: 'Transaction direction' },
  TYPE_OF_CHECK: { id: 'typeOfCheck', name: 'Type of check' },
  UNACCEPTABLE_EMPLOYMENT_TYPES: { id: 'unacceptableEmploymentTypes', name: 'Unacceptable employment statuses' },
  UNACCEPTABLE_SOURCE_FUNDS: { id: 'unacceptableSourceOfFunds', name: 'Unacceptable source of funds' },
  UNACCEPTABLE_SOURCE_INCOME: { id: 'unacceptableSourceOfIncomes', name: 'Unacceptable source of income' },
  UPDATE_FREQ: { id: 'updateFreq', name: 'Data update frequency', unit: 'days' },
  UPPER_AGE_LIMIT: { id: 'upperAgeLimit', name: 'Upper age threshold', unit: 'years' },
  UNIT_OF_TIME: { id: 'unitOfTime', name: 'Unit of time' },
  VALUATION_DEVIATION: { id: 'valuationDeviation', name: 'Valuation deviation' },
  VALUATION_PREFIX: { id: 'valuationPrefix', name: 'Prefix' },
  WINDOW_PERIOD: { id: 'windowPeriod', subIds: ['amount', 'unit'], name: 'Window period' },
  ZIP_CODES: { id: 'zipCodes', name: 'Blocked zip codes' },
} as const;

export type RuleParameters = ValueOf<typeof ruleParameters>

export type RuleParametersKeys = keyof typeof ruleParameters

export default ruleParameters;
